import CouponOnProduct from '@/models/storePanel/coupons/CouponOnProduct';
const getDefaultState = () => ({
  giftCategories: [],
  saleProducts: [],
  giftProducts: [],
  couponsOnProducts: [],
  couponOnProduct: new CouponOnProduct(),
  saleProductsLoading: false,
  giftProductsLoading: false,
  productsLoading: false,
  products: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setGiftCategories(state, payload) {
      state.giftCategories = payload;
    },

    setSaleProducts(state, payload) {
      state.saleProducts = payload;
    },

    setProducts(state, payload) {
      state.products = payload;
    },

    setGiftProducts(state, payload) {
      state.giftProducts = payload;
    },

    setItems(state, payload) {
      state.couponsOnProducts = payload.map((c) => {
        c.product_buy = c.product_buy_name;
        c.product_free = c.product_free_name;
        return c;
      });
    },

    setItem(state, payload) {
      state.couponOnProduct = new CouponOnProduct(payload);
    },

    addItem(state, payload) {
      state.couponsOnProducts.unshift(payload);
    },

    updateItem(state, payload) {
      let index = state.couponsOnProducts.findIndex((c) => c.coupon_id === payload.coupon_id);
      state.couponsOnProducts.splice(index, 1, payload);
    },

    removeItem(state, id) {
      state.couponsOnProducts = state.couponsOnProducts.filter((c) => c.coupon_id !== id);
    },

    setSaleProductsLoading(state, payload) {
      state.saleProductsLoading = payload;
    },

    setProductsLoading(state, payload) {
      state.productsLoading = payload;
    },

    setGiftProductsLoading(state, payload) {
      state.giftProductsLoading = payload;
    },
  },

  actions: {
    async getProducts({ commit }, query) {
      try {
        commit('setProductsLoading', true);
        const { data } = await CouponOnProduct.getProducts(query);

        commit('setProducts', data.data.products);
        commit('setProductsLoading', false);
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    },

    async getGiftCategories({ commit }) {
      try {
        const { data } = await CouponOnProduct.getGiftCategories();

        commit('setGiftCategories', data.data);
      } catch (ex) {
        console.error(ex.response.data.message);
      }
    },

    async getSaleProducts({ commit }, query) {
      try {
        commit('setSaleProductsLoading', true);
        const { data } = await CouponOnProduct.getProducts(query);

        commit('setSaleProducts', data.data.products);
        commit('setSaleProductsLoading', false);
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    },

    async getGiftProducts({ commit }, query) {
      try {
        commit('setGiftProductsLoading', true);
        const { data } = await CouponOnProduct.getProducts(query);

        commit('setGiftProducts', data.data.products);
        commit('setGiftProductsLoading', false);
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    },

    async getItems({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await CouponOnProduct.get(query);

        const { coupons, pagination } = data.data;

        commit('setItems', coupons);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async create({ commit, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });

        let couponOnProduct = { ...state.couponOnProduct };
        delete couponOnProduct.coupon_id;
        delete couponOnProduct.code;
        if (couponOnProduct.action === 'sample') delete couponOnProduct.product_buy_id;

        const { data } = await CouponOnProduct.create(couponOnProduct);
        const { coupon } = data.data;

        commit('addItem', coupon);
        commit('setServerItemsLength', rootState.serverItemsLength + 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created coupon on product!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async update({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        let couponOnProduct = { ...state.couponOnProduct };
        if (couponOnProduct.action === 'sample') delete couponOnProduct.product_buy_id;

        const { data } = await CouponOnProduct.update(couponOnProduct);

        commit('updateItem', data.data.coupon);
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated coupon on product!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async remove({ commit, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });

        await CouponOnProduct.delete(state.couponOnProduct.coupon_id);

        commit('setServerItemsLength', rootState.serverItemsLength - 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDeleteDialog', false, { root: true });
        commit('removeItem', state.couponOnProduct.coupon_id);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully deleted product!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
